export const mSpin = [
  {
    compressed: false,
    requestId: "679bb72f-3f72-4fd0-bada-a414579c8e4e",
    state: "success",
    result: {
      entrySpinId: "679bb72f3f724fd0badaa414579c8e4e",
      spinId: "679bb72f3f724fd0badaa414579c8e4e",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10000,
      moneyAfterSpin: 10010.8,
      diffMoney: 11.2,
      body: '{"DBG":{"bonus":"paid","stops":[45,15,44,121,323,59,99,50,289,355,27,100,36,78,88],"symbolNamesMtrx":[["Jk"],["Jk"],["Jk"],["P2"],["P2"],["P2"],["LP"],["GE"],["P4"],["P2"],["P2"],["P2"],["P4"],["P4"],["P4"]]},"betTotal":40,"bigWinAmt":1120,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"lampFeatures\\":[{\\"coinTypes\\":[2,1,2,1,1,1,1,1],\\"coinValues\\":[-1,3,-2,2,3,3,1,1]}],\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":0,\\"green\\":1,\\"red\\":0}}","isBigWin":2,"lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[45,15,44,121,323,59,99,50,289,355,27,100,36,78,88],"symbolMatrix":[[2],[2],[2],[8],[8],[8],[13],[14],[6],[8],[8],[8],[6],[6],[6]],"symbolMatrixResult":[[2],[2],[2],[8],[8],[8],[13],[14],[6],[8],[8],[8],[6],[6],[6]],"totalWinCoin":1120,"totalWinMeterAfterSpin":1120,"type":"@Reel","winInfoList":[{"DBG":{"Legend":{"sym":"LP"}},"Legend":{"numMatchs":1,"symID":13},"winCoinBeforeMultiply":1120,"winLine":-1,"winPositionList":[[],[],[],[],[],[],[0],[0],[],[],[],[],[],[],[]]}]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
  {
    compressed: false,
    requestId: "f44e425c-8f54-4a49-86e1-2dac93f2da18",
    state: "success",
    result: {
      entrySpinId: "f44e425c8f544a4986e12dac93f2da18",
      spinId: "f44e425c8f544a4986e12dac93f2da18",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10010.8,
      moneyAfterSpin: 10010.4,
      diffMoney: 0,
      body: '{"DBG":{"bonus":"paid","stops":[11,49,7,393,385,138,69,69,303,168,370,333,86,7,91],"symbolNamesMtrx":[["Te"],["Qn"],["Qn"],["Te"],["Kg"],["P4"],["P2"],["Nn"],["P2"],["Qn"],["Kg"],["Ac"],["P2"],["Qn"],["Nn"]]},"betTotal":40,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":0,\\"green\\":1,\\"red\\":0}}","lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[11,49,7,393,385,138,69,69,303,168,370,333,86,7,91],"symbolMatrix":[[1],[3],[3],[1],[4],[6],[8],[0],[8],[3],[4],[5],[8],[3],[0]],"symbolMatrixResult":[[1],[3],[3],[1],[4],[6],[8],[0],[8],[3],[4],[5],[8],[3],[0]],"totalWinCoin":0,"totalWinMeterAfterSpin":0,"type":"@Reel","winInfoList":[]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
  {
    compressed: false,
    requestId: "b6cebf26-239f-43c5-b50b-e9b1a29622c7",
    state: "success",
    result: {
      entrySpinId: "b6cebf26239f43c5b50be9b1a29622c7",
      spinId: "b6cebf26239f43c5b50be9b1a29622c7",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10010.4,
      moneyAfterSpin: 10010,
      diffMoney: 0,
      body: '{"DBG":{"bonus":"paid","stops":[61,99,63,300,62,161,73,91,186,177,382,383,49,79,18],"symbolNamesMtrx":[["Qn"],["Nn"],["BX"],["P1"],["P4"],["P3"],["Ac"],["Te"],["Te"],["Ac"],["Nn"],["Qn"],["P2"],["Ac"],["Ac"]]},"betTotal":40,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"boxTransId\\":4,\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":0,\\"green\\":1,\\"red\\":0}}","lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[61,99,63,300,62,161,73,91,186,177,382,383,49,79,18],"symbolMatrix":[[3],[0],[15],[9],[6],[7],[5],[1],[1],[5],[0],[3],[8],[5],[5]],"symbolMatrixResult":[[3],[0],[4],[9],[6],[7],[5],[1],[1],[5],[0],[3],[8],[5],[5]],"totalWinCoin":0,"totalWinMeterAfterSpin":0,"type":"@Reel","winInfoList":[]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
  {
    compressed: false,
    requestId: "6c5e5d7f-cc76-4dba-8cad-8099799ade42",
    state: "success",
    result: {
      entrySpinId: "6c5e5d7fcc764dba8cad8099799ade42",
      spinId: "6c5e5d7fcc764dba8cad8099799ade42",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10010,
      moneyAfterSpin: 10009.6,
      diffMoney: 0,
      body: '{"DBG":{"bonus":"paid","stops":[26,32,86,164,200,220,66,82,194,394,214,431,81,94,48],"symbolNamesMtrx":[["Qn"],["P4"],["Qn"],["Jk"],["Te"],["P3"],["Nn"],["GE"],["Nn"],["Ac"],["P1"],["P1"],["Te"],["Jk"],["P4"]]},"betTotal":40,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":1,\\"green\\":2,\\"red\\":0}}","lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[26,32,86,164,200,220,66,82,194,394,214,431,81,94,48],"symbolMatrix":[[3],[6],[3],[2],[1],[7],[0],[14],[0],[5],[9],[9],[1],[2],[6]],"symbolMatrixResult":[[3],[6],[3],[2],[1],[7],[0],[14],[0],[5],[9],[9],[1],[2],[6]],"totalWinCoin":0,"totalWinMeterAfterSpin":0,"type":"@Reel","winInfoList":[]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
  {
    compressed: false,
    requestId: "13de754a-1aed-4c7a-a2ed-f3a800e4a19f",
    state: "success",
    result: {
      entrySpinId: "13de754a1aed4c7aa2edf3a800e4a19f",
      spinId: "13de754a1aed4c7aa2edf3a800e4a19f",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10009.6,
      moneyAfterSpin: 10009.2,
      diffMoney: 0,
      body: '{"DBG":{"bonus":"paid","stops":[86,42,24,149,383,253,188,27,186,279,56,235,33,20,71],"symbolNamesMtrx":[["P2"],["MS"],["Kg"],["Nn"],["Jk"],["Nn"],["Jk"],["Qn"],["Te"],["Jk"],["BX"],["P2"],["Nn"],["P2"],["Ac"]]},"betTotal":40,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"boxTransId\\":1,\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":1,\\"green\\":2,\\"red\\":0}}","lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[86,42,24,149,383,253,188,27,186,279,56,235,33,20,71],"symbolMatrix":[[8],[10],[4],[0],[2],[0],[2],[3],[1],[2],[15],[8],[0],[8],[5]],"symbolMatrixResult":[[8],[10],[4],[0],[2],[0],[2],[3],[1],[2],[1],[8],[0],[8],[5]],"totalWinCoin":0,"totalWinMeterAfterSpin":0,"type":"@Reel","winInfoList":[]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
  {
    compressed: false,
    requestId: "d0459991-14e1-40c0-946a-3f25abb5389f",
    state: "success",
    result: {
      entrySpinId: "d045999114e140c0946a3f25abb5389f",
      spinId: "d045999114e140c0946a3f25abb5389f",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10009.2,
      moneyAfterSpin: 10009.05,
      diffMoney: 0.25,
      body: '{"DBG":{"bonus":"paid","stops":[11,65,36,132,337,49,325,64,380,118,250,99,31,34,48],"symbolNamesMtrx":[["Te"],["Jk"],["BX"],["P1"],["Qn"],["BX"],["P2"],["Te"],["Te"],["Jk"],["P3"],["BX"],["P3"],["MS"],["P4"]]},"betTotal":40,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"boxTransId\\":8,\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":1,\\"green\\":2,\\"red\\":0}}","lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[11,65,36,132,337,49,325,64,380,118,250,99,31,34,48],"symbolMatrix":[[1],[2],[15],[9],[3],[15],[8],[1],[1],[2],[7],[15],[7],[10],[6]],"symbolMatrixResult":[[1],[2],[8],[9],[3],[8],[8],[1],[1],[2],[7],[8],[7],[10],[6]],"totalWinCoin":25,"totalWinMeterAfterSpin":25,"type":"@Reel","winInfoList":[{"DBG":{"Legend":{"sym":"P2"}},"Legend":{"numMatchs":4,"symID":8},"winCoinBeforeMultiply":25,"winLine":22,"winPositionList":[[],[],[0],[],[],[0],[0],[],[],[],[],[0],[],[],[]]}]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
  {
    compressed: false,
    requestId: "ecff458b-6fa9-4751-8e6d-b1a93f099576",
    state: "success",
    result: {
      entrySpinId: "ecff458b6fa947518e6db1a93f099576",
      spinId: "ecff458b6fa947518e6db1a93f099576",
      betTotal: 0.4,
      currency: "DMO",
      moneyBeforeSpin: 10009.05,
      moneyAfterSpin: 10008.65,
      diffMoney: 0,
      body: '{"DBG":{"bonus":"paid","stops":[53,85,22,55,213,77,58,19,89,329,309,350,85,70,77],"symbolNamesMtrx":[["P1"],["P1"],["Qn"],["P1"],["P1"],["Ac"],["Kg"],["Ac"],["P2"],["P1"],["Kg"],["Qn"],["Te"],["Te"],["P1"]]},"betTotal":40,"currentBonus":"{\\"bonusName\\":\\"paid\\",\\"spinIndex\\":1,\\"totalSpinCount\\":1}","extraString":"{\\"mirrorBalls\\":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],\\"pot\\":{\\"blue\\":1,\\"green\\":2,\\"red\\":0}}","lineBetCoin":1,"numRows":[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],"reelStrips":["paid_r11","paid_r12","paid_r13","paid_r21","paid_r22","paid_r23","paid_r31","paid_r32","paid_r33","paid_r41","paid_r42","paid_r43","paid_r51","paid_r52","paid_r53"],"stops":[53,85,22,55,213,77,58,19,89,329,309,350,85,70,77],"symbolMatrix":[[9],[9],[3],[9],[9],[5],[4],[5],[8],[9],[4],[3],[1],[1],[9]],"symbolMatrixResult":[[9],[9],[3],[9],[9],[5],[4],[5],[8],[9],[4],[3],[1],[1],[9]],"totalWinCoin":0,"totalWinMeterAfterSpin":0,"type":"@Reel","winInfoList":[]}',
      mathVersion: "",
      isMaxPayout: false,
      requestId: "",
      errorCode: 0,
    },
  },
];
